module.exports = __webpack_public_path__ + "img/aib.8c31dc7e.svg";